<app-view-invoice-basic *ngIf="invoiceId" [contextIdDto]="contextIdDto" [invoiceId]="invoiceId"></app-view-invoice-basic>
